import type { FormRules } from 'element-plus';

export const currencyConverterSettingsFormRules: FormRules = {
  currencyFromList: [
    { required: true, message: 'Please select currency from', trigger: 'change' },
  ],
  currencyTo: [
    { required: true, message: 'Please select currency to', trigger: 'change' },
  ],
};
